import React from 'react';
import DistributionDonut from '../../../components/DistributionDonut/DistributionDonut';
import { VIOLATION_VOCAB } from '../summaryVocab';

/**
 * Два донута со списком рядом: по названиям правил и по метрикам.
 * metric_distribution — основной источник, violation_types — запасной (тот же
 * срез в старом поле ответа).
 */
const DistributionDonutsCard = ({
  ruleDistribution, metricDistribution, violationTypes, vocab = VIOLATION_VOCAB,
}) => {
  const metrics = metricDistribution || violationTypes;
  if (!ruleDistribution && !metrics) return null;

  return (
    <section className="sum-card">
      <h2 className="sum-card-title">{vocab.distributionTitle}</h2>
      <div className="sum-donuts">
        <DistributionDonut
          title="По названиям правил"
          distribution={ruleDistribution}
          unitForms={vocab.unitForms}
          emptyText={vocab.emptyText}
        />
        <DistributionDonut
          title="По метрикам"
          distribution={metrics}
          unitForms={vocab.unitForms}
          emptyText={vocab.emptyText}
        />
      </div>
    </section>
  );
};

export default DistributionDonutsCard;
